<template>
  <div class="agent-item">
    <div class="agent-item__avatar">
      <img :src="agentImage" />
    </div>
    <div v-if="agent.firstName" class="agent-item__name">
      <span>
        {{ agent.firstName }}
        <span v-if="hasAdditionalAccess && hasAgentRole" class="agent-item__name--additional"> (kod dostępu)</span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import avatarMan from '@/assets/images/avatar/avatar_agent_man.jpg';
import avatarWoman from '@/assets/images/avatar/avatar_agent_woman.jpg';

export default {
  name: 'AgentItem',

  props: {
    agent: Object,
    hasAdditionalAccess: Boolean,
  },

  computed: {
    ...mapGetters('auth', ['hasAgentRole']),

    agentImage() {
      const { firstName } = this.agent;
      const firstNameToLowerCase = firstName.toLowerCase();
      const nameExceptions = [
        'kuba',
        'zawisza',
        'jarema',
        'barnaba',
        'bonawentura',
        'kosma',
        'rokita',
        'lasota',
        'żegota',
        'jan maria',
        'nikita',
        'makita',
        'illia',
      ];
      const nameValid = ['noemi', 'miriam', 'beatrycze', 'sophie', 'nikol'];
      const isLastLetterA = firstName.slice(-1) === 'a';

      return (isLastLetterA
        && !nameExceptions.includes(firstNameToLowerCase))
        || nameValid.includes(firstNameToLowerCase)
        ? avatarWoman
        : avatarMan;
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-item {
  @apply flex flex-row p-3 px-12 cursor-pointer;
  @media screen and (min-width: 768px) {
    @apply w-1/2 justify-center;
  }
  @media screen and (min-width: 992px) {
    @apply w-1/3;
  }
  &:hover > &__avatar {
    @apply border-pink;
    box-shadow: 0 7px 14px rgba(0, 0, 0, 0.05), 0 5px 5px rgba(0, 0, 0, 0.12);
  }
  &:hover > &__name {
    @apply text-grey-darkest;
  }
  &__avatar,
  &__name {
    @apply flex justify-center items-center mx-0 px-0 text-lg;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    @media screen and (min-width: 768px) {
      @apply text-2xl px-3;
    }
  }
  &__name {
    @apply text-left;
    @media screen and (min-width: 768px) {
      @apply text-2xl;
    }
    &--additional {
      white-space: nowrap;
    }
  }
  &__avatar {
    flex-shrink: 0;
    @apply p-0 mx-6 bg-white border-solid border-6 border-grey;
    overflow: hidden;
    width: 115px;
    height: 115px;
    border-radius: 34px;
    img {
      object-fit: cover;
      max-width: 105px;
    }
  }
}
</style>
